import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominaDocumentosLayoutsbancariosPendientesLayoutLista', {
    template: template,
    controller: NominaDocumentosLayoutsbancariosPendientesLayoutListaComponent,
    bindings: {
      data: '<',
      onSelect: '&',
    },
  })

function NominaDocumentosLayoutsbancariosPendientesLayoutListaComponent($filter) {
  let $ctrl = this,
    filterBy = $filter('filter'),
    data

  $ctrl.$onChanges = $onChanges
  $ctrl.filtrar = filtrar
  $ctrl.invalidos = undefined
  $ctrl.seleccionados = []
  $ctrl.seleccionarItem = seleccionarItem
  $ctrl.seleccionarItems = seleccionarItems
  $ctrl.todosSeleccionados = false

  function $onChanges(changes) {
    if (changes.data) {
      data = $filter('orderBy')(changes.data.currentValue, ['layout_generado', 'colaborador'])

      filtrar()
      seleccionarItems()
    }
  }

  function filtrar() {
    $ctrl.resultados = filterBy(data, $ctrl.filtro)

    totalizar()
  }

  function seleccionar() {
    let data = [].concat($ctrl.data)
    $ctrl.onSelect({$event: {data: data}})
  }

  function seleccionarItem(item) {
    if (!item.$$valido)
      return

    item.$$seleccionado = item.$$valido && !item.layout_generado && !item.$$seleccionado

    totalizar()
    seleccionar()
  }

  function seleccionarItems(todos) {
    $ctrl.data.forEach(function (item) {
      item.$$seleccionado = item.$$valido && !item.layout_generado && todos
    })

    totalizar()
    seleccionar()
  }

  function totalizar() {
    $ctrl.seleccionados = $ctrl.data.filter((item) => !item.$$valido || item.$$seleccionado)
    $ctrl.todosSeleccionados = $ctrl.resultados.every((item) => !item.$$valido || item.$$seleccionado)
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/documentos/layoutsbancarios/pendientes/layout/lista/component.js